import React from 'react';
import urls, { relativeUrl } from '@/constants/urls';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';

const ReviewAction = () => (
  <RibbonMenu
    name="review"
    icon="thumbs up"
    message="actions.review"
    url={`#${relativeUrl(urls.REVIEW)}`}
    className="aridhia-task-list-action whitespace-nowrap"
  />
);

export default ReviewAction;
